:host {
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  background: var(--white-layout-301-level-0-elevation);
}

.header__actions {
  display: flex;
}

.footer__container {
  display: flex;
  justify-content: space-between;
}

.page__header {
  padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(2.5 * var(--spacer));
  line-height: 33px;
}
